require('angular-elastic');
require('angular-sanitize');
require('angular-scroll');
require('@iamadamjowett/angular-click-outside');
require('./eventFeed.scss');
const controller = require('./eventFeedCtrl').default;
const template = require('./eventFeed.html');

const deps = [
  'duScroll', // angular-scroll
  'monospaced.elastic', // angular-elastic
  'ngSanitize', // angular-sanitize
  'angular-click-outside',
  require('data/util').name,
  require('data/user').name,
  require('ui/web/message').name,
  require('ui/web/infiniteScroll').name,
  require('ui/web/maintainScrollBottom').name,
  require('data/model/client').name,
  require('data/model/unreadMessages').name,
  require('data/collection/message').name,
  require('data/collection/person').name,
  require('data/service/urlParser').name,
  require('data/service/url').name,
  require('data/service/messageParser').name,
  require('data/service/featureFlagService').name,
  require('ui/web/constants').name,
  require('ui/web/inView').name,
  require('ui/web/documentUpload').name,
  require('ui/web/setFocus').name,
  require('ui/web/composeView').name,
  require('ui/bk/requests').name,
];

const eventFeedComponent = {
  bindings: {
    userId: '=',
    clientId: '=',
    editable: '=',
  },
  template,
  controller,
  controllerAs: 'vm',
};

module.exports = angular
  .module('bench.ui.eventFeed', deps)
  .component('blEventFeed', eventFeedComponent);
